import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';
import axios from 'axios';

const AddNavCoursePage = () => {
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        pageName: '',
        bannerHeading: '',
        bannerText: '',
        title: '',
        heading: '',
        subHeading: '',
        image: null,
        imgHeading: '',
        imgpara1: '',
        imgpara2: '',
        tableHeading: '',
        tableText: '',
    });


    const handleImageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setFormData({ ...formData, image: e.target.files[0] });
        }
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle point input change
    const handlePointChange = (index, e) => {
        const updatedPoints = formData.points.map((point, i) =>
            i === index ? e.target.value : point
        );
        setFormData((prevData) => ({
            ...prevData,
            points: updatedPoints,
        }));
    };

    // Add new point input
    const addPoint = () => {
        setFormData((prevData) => ({
            ...prevData,
            points: [...prevData.points, ''],
        }));
    };

    // Remove point input
    const removePoint = (index) => {
        const updatedPoints = formData.points.filter((_, i) => i !== index);
        setFormData((prevData) => ({
            ...prevData,
            points: updatedPoints,
        }));
    };

    // Handle form submission
    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const formDataToSend = new FormData();

    //     formDataToSend.append('pageName', formData.pageName);
    //     formDataToSend.append('bannerHeading', formData.bannerHeading);
    //     formDataToSend.append('bannerText', formData.bannerText);
    //     formDataToSend.append('title', formData.title);
    //     formDataToSend.append('heading', formData.heading);
    //     formDataToSend.append('subHeading', formData.subHeading);
    //     formDataToSend.append('imgHeading', formData.imgHeading);
    //     formDataToSend.append('imgpara1', formData.imgpara1);
    //     formDataToSend.append('imgpara2', formData.imgpara2);
    //     formDataToSend.append('tableHeading', formData.tableHeading);
    //     formDataToSend.append('tableText', formData.tableText);

    //     // Image file
    //     if (formData.image) {
    //         formDataToSend.append('image', formData.image);
    //     }

    //     try {

    //         const response = await axios.post(`${config.API_BASE_URL}/api/admin/add_navcoursespage`, formDataToSend);

    //         const result = await response.json();
    //         if (response.data.code == 201) {
    //             alert('Course created successfully');
    //             navigate("/navcoursepagelist");
    //             console.log(result);
    //         } else {
    //             alert('Error creating course');
    //             console.error(result);
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         alert('There was an error with your request.');
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const formDataToSend = new FormData();
    
        formDataToSend.append('pageName', formData.pageName);
        formDataToSend.append('bannerHeading', formData.bannerHeading);
        formDataToSend.append('bannerText', formData.bannerText);
        formDataToSend.append('title', formData.title);
        formDataToSend.append('heading', formData.heading);
        formDataToSend.append('subHeading', formData.subHeading);
        formDataToSend.append('imgHeading', formData.imgHeading);
        formDataToSend.append('imgpara1', formData.imgpara1);
        formDataToSend.append('imgpara2', formData.imgpara2);
        formDataToSend.append('tableHeading', formData.tableHeading);
        formDataToSend.append('tableText', formData.tableText);
    
        if (formData.image) {
            formDataToSend.append('image', formData.image);
        }
    
        try {
            const response = await axios.post(`${config.API_BASE_URL}/api/admin/add_navcoursespage`, formDataToSend);
    
            if (response.data.code === 201) {
                alert('Course created successfully');
                navigate("/admin/navcoursepagelist");
                console.log(response.data);
            } else {
                alert('Error creating course');
                console.error(response.data);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was an error with your request.');
        }
    };
    


    return (
        <div className="container mt-5 pt-5">
           <div className="row">
            <div className="col-lg-2"></div>
            <div className="col-lg-10">
            <h2>Create New Course</h2>
            <form onSubmit={handleSubmit}>
                {/* Page Name */}
                <div className="mb-3">
                    <label htmlFor="pageName" className="form-label">Page Name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="pageName"
                        name="pageName"
                        value={formData.pageName}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Banner Heading */}
                <div className="mb-3">
                    <label htmlFor="bannerHeading" className="form-label">Banner Heading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="bannerHeading"
                        name="bannerHeading"
                        value={formData.bannerHeading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Banner Text */}
                <div className="mb-3">
                    <label htmlFor="bannerText" className="form-label">Banner Text</label>
                    <textarea
                        className="form-control"
                        id="bannerText"
                        name="bannerText"
                        rows="3"
                        value={formData.bannerText}
                        onChange={handleInputChange}
                        required
                    ></textarea>
                </div>

                {/* Title Text */}
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title</label>
                    <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Table Heading */}

                <div className="mb-3">
                    <label htmlFor="tableHeading" className="form-label">Table Heading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="tableHeading"
                        name="tableHeading"
                        value={formData.tableHeading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Table Text */}
                <div className="mb-3">
                    <label htmlFor="tableText" className="form-label">Table Text</label>
                    <textarea
                        className="form-control"
                        id="tableText"
                        name="tableText"
                        rows="3"
                        value={formData.tableText}
                        onChange={handleInputChange}
                        required
                    ></textarea>
                </div>


                {/* Heading */}
                <div className="mb-3">
                    <label htmlFor="heading" className="form-label">Container Main Heading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="heading"
                        name="heading"
                        value={formData.heading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Subheading */}
                <div className="mb-3">
                    <label htmlFor="subHeading" className="form-label">Container Main Subheading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="subHeading"
                        name="subHeading"
                        value={formData.subHeading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <input
                    type="file"
                    className="form-control"
                    id="image"
                    name="image"
                    onChange={handleImageChange}  // remove "value" from file input
                    required
                />

                {/* Image Heading */}
                <div className="mb-3">
                    <label htmlFor="imgHeading" className="form-label">Image Heading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="imgHeading"
                        name="imgHeading"
                        value={formData.imgHeading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Image Paragraphs */}
                <div className="mb-3">
                    <label htmlFor="imgpara1" className="form-label">Image Paragraph 1</label>
                    <textarea
                        className="form-control"
                        id="imgpara1"
                        name="imgpara1"
                        rows="3"
                        value={formData.imgpara1}
                        onChange={handleInputChange}
                        required
                    ></textarea>
                </div>

                <div className="mb-3">
                    <label htmlFor="imgpara2" className="form-label">Image Paragraph 2</label>
                    <textarea
                        className="form-control"
                        id="imgpara2"
                        name="imgpara2"
                        rows="3"
                        value={formData.imgpara2}
                        onChange={handleInputChange}
                        required
                    ></textarea>
                </div>
                {/* Submit Button */}
                <button type="submit" className="btn btn-primary">Submit</button>
            </form>
            </div>
           </div>
        </div>
    );
};

export default AddNavCoursePage;
